import React, { useCallback, useEffect, useRef, useState } from "react";
import { AssigneeSearch, StyledInput } from "../Styled";
import IconButton from "../../../../../shared/components/IconButton";
import RemoveIcon from "../../../../../shared/svg/RemoveIcon";
import { debounce } from "lodash";
import { Anchor, CustomMenuItem } from "./Styled";

interface SearchBarProps {
    fetchItems: Function;
    onFocus?: any;
    currentValue: string;
    setCurrentValue: Function;
}

const DEBOUNCE_TIME = 300;

const SearchBar = ({ fetchItems, onFocus, currentValue, setCurrentValue }: SearchBarProps) => {
    const [text, setText] = useState("");
    const [isFocus, setIsFocus] = useState(false);

    useEffect(() => {
        setText(currentValue);
    }, [currentValue]);
    

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debounceFetchItems = useCallback(
        debounce(
            (searchQuery) => fetchItems({ search: searchQuery }),
            DEBOUNCE_TIME
        ),
        [fetchItems]
    );

    const onSetText = (event: any) => {
        const searchQuery = event.target.value;
        setText(searchQuery);
        debounceFetchItems(searchQuery);
    };

    const onFocusInput = (event: any) => {
        setIsFocus(true);
        if (onFocus) {
            onFocus(event);
        }
    };

    const onBlurInput = () => {
        setIsFocus(false);
    };

    const clearAllText = () => {
        setText("");
        setCurrentValue("");
        fetchItems({ search: "" });
    };

    return (
        <AssigneeSearch isFocus={isFocus}>
            <StyledInput
                placeholder="Chưa bàn giao"
                value={text}
                onChange={onSetText}
                onFocus={onFocusInput}
                onBlur={onBlurInput}
            />
            <IconButton onClick={clearAllText}>
                <RemoveIcon />
            </IconButton>
        </AssigneeSearch>
    );
};

interface UserSearchProps {
    fetchItems: Function;
    getItemText: Function;
    menuList: any[];
    currentValue: any;
    setCurrentValue: any;
}
export const UserSearch = ({
    menuList,
    getItemText,
    fetchItems,
    currentValue,
    setCurrentValue,
}: UserSearchProps) => {
    const [isAnchored, setIsAnchored] = useState(false);
    const containerRef = useRef(null);
    const anchorRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (
                containerRef.current &&
                !(containerRef.current as any).contains(event.target) &&
                anchorRef.current &&
                !(anchorRef.current as any).contains(event.target)
            ) {
                setIsAnchored(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const onClickMenu = (item: any) => {
        setCurrentValue(item);
        setIsAnchored(false);
    };

    return (
        <div style={{ position: "relative" }} ref={containerRef}>
            <SearchBar
                fetchItems={fetchItems}
                onFocus={() => setIsAnchored(true)}
                currentValue={currentValue}
                setCurrentValue={setCurrentValue}
            />
            {isAnchored && (
                <Anchor ref={anchorRef}>
                    {menuList.map((item: any) => (
                        <CustomMenuItem onClick={() => onClickMenu(item)}>
                            {getItemText(item)}
                        </CustomMenuItem>
                    ))}
                </Anchor>
            )}
        </div>
    );
};
